module.exports = __webpack_public_path__ + "static/media/promo-image-loyalty.7f3f50f9.png";